import React, { useState } from "react";
import Sidebar from "./Sidebar";
import TopHeader from "../TopHeader";
const Layout = ({ children }) => {
  const [show, setShow] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const [unread, setUnread] = useState(false)
  const [unreadReq, setUnreadReq] = useState(false)

  const hideUnhide = () => {
    setShow(!show);
  }

  const handleUnread = (val) => {
    setUnread(val)
  }

    const handleUnreadChange = (val) => {
    setUnreadReq(val)
  }

  return (
    <div>
      <div className="main-wrap">
        <div className={show ? "left-side hide" : "left-side "}>
          <Sidebar
            isActive={isActive}
            setIsActive={setIsActive}
            show1={show}
            setShow={setShow}
            unread={unread}
          />
        </div>
        <div className={show ? "right-side-cmn hide" : "right-side-cmn "}>
          <TopHeader 
          hideUnhide={hideUnhide} 
          handleUnread={handleUnread} 
          handleUnreadChange={handleUnreadChange} 
          unreadReq={unreadReq}
          />
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
